<template>
<div>
	<collapsible-panel :external-toggle="panelOpen" panel-size="md" v-on:panelRetract="panelOpen = false">
		<template slot="panel">

			<div class="inner-scroll">
				<h3>Add to Schedule</h3>

				<template v-if="!serviceId && !projectId">

					<accordion 
						heading="Personal Event" 
						:start-open="!hasModulePermWrite('Schedule')">

						<component :is="calendarView == 'daily' && $store.windowWidth > 1000 ? 'draggable' : 'div'"
							class="list-group" 
							:value="selfUserEvents"
							group="items"
							:sort="false"
							v-on:start="dragStart"
							v-on:end="dragEnd"
							v-on:choose="dragChoose"
							v-on:unchoose="dragCancel">

							<a v-for="event in selfUserEvents" href="#" class="list-group-item list-group-item-action">
								<div class="d-flex justify-content-between">
									<div>
										<i class="fa fa-fw" :class="{
											'fa-first-aid' : event.is_sickday == 1,
											'fa-umbrella-beach' : event.is_vacation == 1,
											'fa-calendar-alt' : !event.is_vacation && !event.is_sickday
										}"></i>
										{{ event.label }}
									</div>
									<i class="fa fa-plus icon-button" v-on:click="entityAddClick('user',event)"></i>
								</div>
							</a>
						</component>
					</accordion>

					<accordion v-if="hasModulePermWrite('Schedule')" heading="Projects">
						<search-bar
							v-model="projectSearchTerms"
							placeholder="Search Projects..."
							full-width="true">		
						</search-bar>

						<div class="p-2 pb-0">
							<field v-model="projectListFilters"
								:params="{type:'checklist',options:[
									{text: 'Show only unscheduled',value:'only-unscheduled'},
									{text: 'My projects',value:'my-projects'}
								]}">
							</field>
						</div>

						<component :is="calendarView == 'daily' ? 'draggable' : 'div'" v-if="mutatedProjects.length > 0"
							class="list-group" 
							:value="mutatedProjects"
							group="items"
							v-on:start="dragStart"
							v-on:end="dragEnd"
							:sort="false">

							<a v-for="project in mutatedProjects" href="#" class="list-group-item list-group-item-action" v-on:click="entityAddClick('project',project)">
								<div class="d-flex justify-content-between flex-wrap align-items-center inner">
									<div>{{ project.description }}</div>
									<span v-if="calcHoursScheduled(project,'job_id',selectedDate) > 0" class="badge badge-primary">
										{{calcHoursScheduled(project,'job_id',selectedDate).toFixed(1)}} hrs
									</span>
									
									<i class="fa fa-plus icon-button" v-on:click="entityAddClick('project',project)"></i>
									
								</div>
							</a>
						</component>
						<spinner v-else :inline="true"></spinner>
					</accordion>

					<accordion v-if="hasModulePermWrite('Schedule')" heading="Services">
						<search-bar
							v-model="serviceSearchTerms"
							placeholder="Search Services..."
							full-width="true">		
						</search-bar>

						<div class="p-2 pb-0">
							<field v-model="serviceListFilters"
								:params="{type:'checklist',options:[
									{text: 'Show only unscheduled',value:'only-unscheduled'},
									{text: 'My services',value:'my-services'}
								]}">
							</field>
						</div>

						<component :is="calendarView == 'daily' && $store.windowWidth > 1000 ? 'draggable' : 'div'" v-if="mutatedServices.length > 0"
							class="list-group" 
							:value="mutatedServices"
							group="items"
							v-on:start="dragStart"
							v-on:end="dragEnd"
							:sort="false">

							<a v-for="service in mutatedServices" href="#" class="list-group-item list-group-item-action">
								<div class="d-flex justify-content-between flex-wrap align-items-center inner">
									<div>{{ service.description }}</div>
									<span v-if="calcHoursScheduled(service,'service_id',selectedDate) > 0" class="badge badge-primary">
										{{calcHoursScheduled(service,'service_id',selectedDate).toFixed(1)}} hrs
									</span>

									<i class="fa fa-plus icon-button" v-on:click="entityAddClick('service',service)"></i>
								</div>
							</a>
						</component>
						<spinner v-else :inline="true"></spinner>
					</accordion>
				</template>

				<component :is="calendarView == 'daily' && $store.windowWidth > 1000 ? 'draggable' : 'div'" v-else-if="projectId"
					style="cursor: pointer;"
					class="list-group mb-2"
					:value="[$store.project]"
					v-on:start="dragStart"
					v-on:end="dragEnd"
					group="items">

					<div class="list-group-item-action list-group-item d-flex justify-content-between">
						Project #{{ $store.project.job_num }}

						<i class="fa fa-plus icon-button" v-on:click="entityAddClick('project',$store.project)"></i>
					</div>

				</component>

				<component :is="calendarView == 'daily' && $store.windowWidth > 1000 ? 'draggable' : 'div'" v-else-if="serviceId"
					style="cursor: pointer;"
					class="list-group mb-2"
					:value="[$store.service]"
					v-on:start="dragStart"
					v-on:end="dragEnd"
					group="items">

					<div class="list-group-item-action list-group-item d-flex justify-content-between">
						Service #{{ $store.service.job_num }}

						<i class="fa fa-plus icon-button" v-on:click="entityAddClick('service',$store.service)"></i>
					</div>

				</component>

				<template v-if="hasModulePermWrite('Schedule')">
					<accordion heading="Employees">
						<search-bar v-model="employeeSearchTerms" placeholder="Search Employees..." full-width="true"></search-bar>

						<div class="p-2 pb-0">
							<field v-model="employeeListFilters"
								:params="{type:'checklist',options:[
									{text: 'Hide salaried employees',value:'hide-salaried-employees'},
									{text: 'Show only unscheduled',value:'only-unscheduled'}
								]}">
							</field>
						</div>

						<component :is="calendarView == 'daily' && $store.windowWidth > 1000 ? 'draggable' : 'div'" v-if="mutatedUsers.length > 0"
							class="list-group" 
							:value="mutatedUsers"
							group="items"
							:sort="false"
							v-on:start="dragStart($event,true)"
							v-on:end="dragEnd"
							v-on:choose="dragChoose"
							v-on:unchoose="dragCancel">

							<a v-for="user in mutatedUsers" href="#" class="list-group-item list-group-item-action" :title="user.tooltip">
								<div class="d-flex justify-content-between flex-wrap align-items-center inner">
									<div>
										<i v-if="user.hasTimeOffScheduled" class="fa fa-ban text-warning" :title="user.description+' has time off scheduled today'"></i>
										{{ user.description }}
									</div>
									<span v-if="calcHoursScheduled(user,'user_id',selectedDate) > 0" class="badge badge-primary">{{calcHoursScheduled(user,'user_id',selectedDate).toFixed(1)}} hrs</span>
									<i class="fa fa-plus icon-button" v-on:click="entityAddClick('user',user)"></i>
								</div>
							</a>
						</component>
						<spinner v-else :inline="true"></spinner>
					</accordion>

					<accordion heading="Equipment">
						<div class="p-2">
							<equipment-picker draggable-group="items" 
								:is-draggable="calendarView == 'daily' && $store.windowWidth > 1000 ? true : false" 
								:hide-meta="true"
								:attached-data="scheduledEquipmentWithTotalHours"
								v-on:addClick="entityAddClick('equipment',$event)"
								v-on:start="dragStart"
								v-on:end="dragEnd"
								v-on:dragChoose="dragChoose"
								v-on:dragUnchoose="dragCancel">
							</equipment-picker>
						</div>
					</accordion>

				</template>
			</div>
		</template>
		<template slot="main">
			
			<div class="schedule-top-controls-container">
				<div class="d-flex flex-wrap justify-content-between align-items-center">
					<div class="d-flex align-items-center heading-block">
						<div class="alert mb-0" :class="{
								'alert' : calendarView == 'daily',
								'alert-success' : dayIsPublished,
								'alert-dark' : !dayIsPublished
							}">
							<div class="d-flex align-items-center mr-3">
								<i class="icon-button fa fa-chevron-left" v-on:click="decrementSelectedDate"></i>
								<h2 class="schedule-heading m-0 mr-2 ml-2">{{scheduleHeading}}</h2>
								<i class="icon-button fa fa-chevron-right" v-on:click="incrementSelectedDate"></i>
								<span v-if="calendarView == 'daily' && dayIsPublished" class="ml-2" style="margin-right: -20px;">Published</span>
								<span v-else-if="calendarView == 'daily'" class="ml-2" style="margin-right: -20px;">Un-published</span>
							</div>
						</div>

						<!--
						<div class="schedule-controls schedule-controls-desktop" :class="{visible: showScheduleControls}">

							<publish-controls
								:day-is-published="dayIsPublished"
								:calendar-view="calendarView"
								:schedule-rows="scheduleRows"
								:selected-date="selectedDate"
								v-on:publish="publishUnpublishDay(1)"
								v-on:unpublish="publishUnpublishDay(0)"
								v-on:sendNotices="sendNotices">
							</publish-controls>
						</div>
						-->

						
					</div>

					<div class="d-flex justify-content-end align-items-center" style="margin-left: auto;">
						<button class="btn btn-light btn-sm mr-2" v-on:click="iconLegendModal.visible = true">
							Icon Legend
						</button>

						<context-menu menu-label="View"
							:icon-right="true"
							:button-border="true"
							icon="fa-chevron-down"
							:menu-items="viewMenuButtons"
							v-on:activateDayShiftView="activateDayShiftView"
							v-on:activateNightShiftView="activateNightShiftView"
							v-on:activateFullDayView="activateFullDayView"
							v-on:activateDailyView="calendarView = 'daily';calendarViewChange('daily')"
							v-on:activateWeeklyView="calendarView = 'weekly';calendarViewChange('weekly')"
							v-on:activateMonthlyView="calendarView = 'monthly';calendarViewChange('monthly')"
							v-on:openFilterPanel="openFilterPanel">
						</context-menu>

						<context-menu menu-label="Actions"
							:icon-right="true"
							:button-border="true"
							icon="fa-chevron-down"
							:menu-items="actionMenuButtons"
							v-on:addToSchedule="addToSchedule"
							v-on:publishDay="publishUnpublishDay(1)"
							v-on:unpublishDay="publishUnpublishDay(0)"
							v-on:sendNotices="sendNoticeConfirmModal.visible = true">
						</context-menu>
					</div>

					<!--
					<div>
						<i title="Open schedule controls" v-if="!showScheduleControls" class="schedule-controls-button-open fa icon-button fa-ellipsis-v" v-on:click="showScheduleControls = true"></i>
						<i v-else class="schedule-controls-button-close fa icon-button fa-times" v-on:click="showScheduleControls = false"></i>
					</div>
					-->
				</div>

			</div>

			<div v-if="showFilterPanel" class="p-2 mb-2 bg-light flex-grow-1" style="margin-top: 10px;">
				<div class="d-flex justify-content-between">
					<h5>Filter Schedule</h5>

					<i class="fa fa-times icon-button" v-on:click="showFilterPanel = false"></i>
				</div>
				<div class="row">
					<div class="col-lg-3">
						<field label="Filter to specific event types"
							col-class="col-auto"
							:params="{type:'boolean'}"
							v-model="typeFiltering"
							v-on:change="typeFilterToggleChange">
						</field>

						<field v-if="typeFiltering"
							:params="{
								type: 'select-multi',
								closeOnSelect:false,
								options: [
									{text: 'Project Events',value:'project'},
									{text: 'Service Events',value:'service'},
									{text: 'Equipment Events',value: 'equipment'},
									{text: 'Equipment Servicing Events',value: 'equipment-servicing'},
									{text: 'Employee Events',value: 'user'}
								]
							}"
							v-model="filters.mainTypes"
							v-on:change="filterMainTypeChange">
						</field>

					</div>
					<div class="col-lg-3">

						<field label="Filter to specific projects"
							col-class="col-auto"
							:params="{type:'boolean'}"
							v-model="projectFiltering">
						</field>
						<div v-if="projectFiltering">
							<job-picker
								:hide-label="true"
								:multi="true"
								job-type="project" 
								key="project"
								v-model="filters.projectIds"
								v-on:close="close">
							</job-picker>
							<field label="Show only related events"
								col-class="col-auto"
								:params="{type:'boolean'}"
								v-model="filters.showOnlyRelated">
							</field>
						</div>
					</div>
					<div class="col-lg-3">

						<field label="Filter to specific services"
							col-class="col-auto"
							:params="{type:'boolean'}"
							v-model="serviceFiltering">
						</field>
						<div v-if="serviceFiltering">
							<job-picker
								:hide-label="true"
								:multi="true"
								key="project"
								job-type="project" 
								v-model="filters.serviceIds"
								v-on:close="close">
							</job-picker>
							<field label="Show only related events"
								col-class="col-auto"
								:params="{type:'boolean'}"
								v-model="filters.showOnlyRelated">
							</field>
						</div>
					</div>
					<div class="col-lg-3">

						<field label="Filter to specific employees"
							col-class="col-auto"
							:params="{type:'boolean'}"
							v-model="userFiltering">
						</field>
						<field v-if="userFiltering"
							:params="{
								type: 'select-multi',
								options: optionify(employeesOnSchedule,'displayField')
							}"
							v-model="filters.userIds">
						</field>
					</div>

						<!--
						<field label="Filter to specific equipment"
							col-class="col-auto"
							:params="{type:'boolean'}"
							v-model="equipmentFiltering">
						</field>
						<field v-if="equipmentFiltering"
							label="Equipment"
							col-class="col-auto"
							:params="{
								type: 'select-multi',
								options: equipmentOptions
							}"
							v-model="filters.equipmentIds">
						</field>
						-->

				</div>
				<div>
					<field label="My events only"
						col-class="col-auto"
						:params="{type:'boolean'}"
						v-model="filters.mineOnly"
						v-on:change="mineOnlyChange">
					</field>
				</div>
			</div>

			<div class="schedule-grid mt-2">

				<div>{{ calendarViewStateLabel }}</div>
				<div v-if="calendarView == 'daily'" class="day-view" :class="{'fixed-height' : (serviceId || projectId) && $store.windowWidth < 1000}" ref="dayView">

					<div class="day-view-inner" :style="{width: scheduleWidth}">
						<div class="time-axis">
							<div v-for="(block,index) in timeBlocks" v-if="(shiftsDisplay == 'full-day' && index % 2 == 0) || shiftsDisplay != 'full-day'" class="time-block"
								:style="{width: modifiedIncrementWidth+'px'}">
								{{block}}
							</div>
						</div>

						<div v-if="!dayIsPublished && panelOpen && droppableVisible" class="add-to-schedule-droppable" :style="{height: (itemHeight*2)+'px'}">
							<draggable v-for="(block,index) in droppableBlocks"
								:style="{
									width: incrementWidth+'px',
									height: (itemHeight*2)+'px'
								}"
								group="items"
								:key="'schedule-block'+index"
								class="droppable-block" 
								v-model="scheduleEntities[index]"
								v-on:change="dropped($event,index)">
							</draggable>
						</div>

						<div class="schedule-rows" :style="{height: scheduleRowsHeight,marginTop: !dayIsPublished && panelOpen && droppableVisible ? '-7px' : 0}">

							<div v-if="shiftsDisplay == 'night-shift-only'" class="day-divider-line" :style="{left: dayDividerLineLeft, height: indicatorLineHeights}"></div>

							<div class="current-time-indicator-line" :style="{left: timeIndicatorLineLeft, height: indicatorLineHeights}"></div>

							<div v-for="(row,rowIndex) in filterRenderedScheduleRows(scheduleRows)"
								class="schedule-row" 
								:class="{
									'project-related-row': 'isProjectRelatedRow' in row && row.isProjectRelatedRow || row.type == 'project',
									'service-related-row': 'isServiceRelatedRow' in row && row.isServiceRelatedRow || row.type == 'service',
									'job-row': row.type == 'project' || row.type == 'service' 
								}"
								:style="{height: itemHeight+'px'}">

								<div v-for="(item,itemIndex) in row.items"
									class="scheduled-item">

									<vue-draggable-resizable
										class="scheduled-item-inner"
										:class="{
											'is-empty-block': 'itemUnrelatedToParent' in item && item.itemUnrelatedToParent,
											'is-project-tile' : item.type == 'project',
											'is-service-tile' : item.type == 'service',
											'starts-to-left' : calcIndexFromMoment(item.startMoment,selectedDate) < 0,
											'bg-warning' : item.is_off == 1
										}"
										axis="x"
										:key="itemIndex+'_'+rand"
										:grid="[incrementWidth,1]"
										:x="calcItemAdjustedX(item.startMoment)"
										:h="itemHeight"
										:w="calcItemAdjustedWidth(item)"
										:handles="['ml','mr']"
										:draggable="!dayIsPublished && item.type != 'equipment-servicing' && !isTouchscreen"
										:resizable="!dayIsPublished && item.type != 'equipment-servicing' && !isTouchscreen"
										:title="item.description+' '+item.startMoment.format('hh:mm A')+' '+item.endMoment.format('hh:mm A')"
										class-name-resizing="scheduled-item-resizing"
										v-on:resizing="setActiveItemIndexes(rowIndex,itemIndex)"
										v-on:dragging="setActiveItemIndexes(rowIndex,itemIndex)"
										v-on:resizestop="changeItemStartEnd"
										v-on:dragstop="changeItemStartEnd"
										v-on:dblclick.native="editFromDaily(rowIndex,itemIndex)">

										<component v-if="!('itemUnrelatedToParent' in item) || !item.itemUnrelatedToParent"
											:is="(activeRowIndex != rowIndex || activeItemIndex != itemIndex) && (item.type == 'service' || item.type == 'project') ? 'draggable' : 'div'"
											group="items"
											class="d-flex justify-content-between align-items-center" 
											:class="{
												'hide-details-on-active': calcBlockWidthFromDuration(item.duration) < 160,
												'draggable-target' : (activeRowIndex != rowIndex || activeItemIndex != itemIndex) && (item.type == 'service' || item.type == 'project')
											}"
											style="height: 100%;"
											:key="itemIndex+'_'+rand+'_inner'"
											v-on:add="droppedIntoJob($event,item)">

											<template v-if="!dragging || (item.type != 'service' && item.type != 'project')">
												<div class="d-flex align-items-center">
													<schedule-card-indicators 
														class="ml-1 mr-1" 
														:event-item="item"
														:selected-date="selectedDate">
													</schedule-card-indicators>
													<div class="scheduled-item-details">
														
														<router-link v-if="item.type == 'equipment-servicing'" :to="'/equipment/edit/'+item.equipmentSlug+'/log'">
															<span v-html="item.shortDescription"></span>
															<template v-if="1 == 2">{{ item.startMoment.format("hh:mm A") }} - {{ item.endMoment.format("hh:mm A") }}</template>
														
															<i class="fa fa-external-link-alt ml-2"></i>
														</router-link>
														<template v-else>
															<span v-html="item.shortDescription"></span>
															<template v-if="1 == 2">{{ item.startMoment.format("hh:mm A") }} - {{ item.endMoment.format("hh:mm A") }}</template>
														</template>
													</div>
												</div>
												<div class="scheduled-item-controls">
													<button class="btn btn-sm btn-light" v-on:click="editFromDaily(rowIndex,itemIndex)">
														<i class="fa fa-pencil-alt"></i>
													</button>			
												</div>
											</template>
											<div v-else class="drop-target">
												<i class="fa fa-box-open"></i>
												<span v-html="item.shortDescription"></span>
											</div>
										</component>

									</vue-draggable-resizable>
								</div>
							</div>

							<draggable v-if="!dayIsPublished && panelOpen && droppableOffVisible" 
								group="items"
								:key="'off-schedule-block'"
								class="off-droppable-block alert alert-danger ml-2"
								v-on:add="droppedIntoOff">
								<div class="d-flex justify-content-between">
									<span>
										<i class="fa fa-ban"></i>
										OFF for the day
									</span>
									<span>
										<i class="fa fa-ban"></i>
										OFF for the day
									</span>
									<span>
										<i class="fa fa-ban"></i>
										OFF for the day
									</span>
									<span>
										<i class="fa fa-ban"></i>
										OFF for the day
									</span>
									<span>
										<i class="fa fa-ban"></i>
										OFF for the day
									</span>
								</div>
							</draggable>
						</div>

					</div>
				</div>
				<weekly-view v-else-if="calendarView == 'weekly'" 
					:selected-date="selectedDate"
					:events="events"
					:equipment-servicing="equipmentServices"
					:filtering='{
						projectFiltering,
						serviceFiltering,
						equipmentFiltering,
						userFiltering,
						filters
					}'
					v-on:dayClick="daySelected"
					v-on:itemClick="editItem">
				</weekly-view>
				<monthly-view v-else-if="calendarView == 'monthly'"
					:selected-date="selectedDate"
					:schedule-events="events"
					:equipment-servicing="equipmentServices"
					:filtering='{
						projectFiltering,
						serviceFiltering,
						equipmentFiltering,
						userFiltering,
						filters
					}'
					v-on:itemClick="editItem"
					v-on:daySelected="daySelected">
				</monthly-view>
			</div>
		</template>
	</collapsible-panel>

	<schedule-event-edit-modal :visible="itemModalEdit.visible"
		:create-record="itemModalEdit.createRecord"
		:record="itemModalEdit.item"
		:schedule-rows="scheduleRows"
		:projects-on-schedule="projectsOnSchedule"
		:services-on-schedule="servicesOnSchedule"
		v-on:scheduleRowsUpdated="updateScheduleRows"
		v-on:closeModal="itemModalEdit.visible = false"
		v-on:eventDeleted="eventDeleted"
		v-on:eventSaved="eventSaved">
	</schedule-event-edit-modal>

	<modal-dialog :modal-visible="sendNoticeConfirmModal.visible"
		title="Send Schedule Notices"
		confirm-button-text="Send"
		:working="sendNoticeConfirmModal.working"
		v-on:confirm="confirmSendNotices"
		v-on:closeModal="sendNoticeConfirmModal.visible = false">

		Would you like to send notifications out to everyone scheduled for this day?

	</modal-dialog>

	<modal-dialog :modal-visible="duplicateConfirmModal.visible"
		title="Duplicate Event?"
		confirm-button-text="Yes, Duplicate"
		cancel-button-text="No"
		:working="duplicateConfirmModal.working"
		v-on:confirm="confirmDuplicateEvent"
		v-on:closeModal="duplicateConfirmModal.visible = false;fetchScheduleEvents()">

		Would you like to duplicate this event to future related job events?

	</modal-dialog>

	<modal-dialog v-if="infoModal.visible"
		:modal-visible="infoModal.visible"
		title="Event Information"
		:submit-visible="false"
		cancel-button-text="Done"
		v-on:closeModal="infoModal.visible = false"
		class="info-modal">

		<h3>
			<i class="fa fa-fw" :class="typeIcon(infoModal.record.type)"></i>
			<i v-if="infoModal.record.type == 'user'" class="fa-fw ml-1 mr-1" :class="{
				'fa-umbrella-beach fas' : infoModal.record.is_vacation == 1,
				'fa-first-aid fa': infoModal.record.is_sickday == 1,
				'fa-ban fas' : infoModal.record.is_off == 1
			}"></i>

			<template v-if="'User' in infoModal.record && infoModal.record.User">
				{{ infoModal.record.User.first_name }} {{ infoModal.record.User.last_name }}
			</template>
			<template v-else-if="'Equipment' in infoModal.record && infoModal.record.Equipment">
				{{ infoModal.record.Equipment.description }}
			</template>

			<small v-if="infoModal.record.is_vacation == 1">
				(VACATION)
			</small>
			<small v-else-if="infoModal.record.is_sickday == 1">
				(MEDICAL LEAVE)
			</small>
			<small v-else-if="infoModal.record.is_off == 1">
				(UNSCHEDULED)
			</small>

		</h3>

		<template v-if="infoModal.jobRecord">
			<h3 style="text-transform: uppercase;">
				<router-link :to="infoModal.record.type == 'service' ? '/service/'+infoModal.jobRecord.slug+'/dashboard' : '/project/'+infoModal.jobRecord.slug+'/dashboard'">
					{{ infoModal.record.type == "service" ? "Service" : "Project"}} #{{ infoModal.jobRecord.job_num }}
					<div>
						<small v-if="infoModal.record.type == 'project'">{{ infoModal.record.Job.job_name }}</small>
					</div>
				</router-link>
			</h3>

			<div v-if="'Customer' in infoModal.jobRecord && infoModal.jobRecord.Customer" class="info-field">
				Customer: <strong>{{ infoModal.jobRecord.Customer.name }}</strong>
			</div>

			<p class="info-field">
				{{ infoModal.jobRecord.address }}, {{ infoModal.jobRecord.city }}
			</p>
		 </template>
		 
		<div class="info-field">
			Scheduled: <strong>{{ eventStartEndTimeFormatted(infoModal.record.startMoment,infoModal.record.endMoment) }}</strong>
		</div>

		<div class="info-field">
			Starting At: <strong>{{ infoModal.record.starting_location }}</strong>
		</div>

		<p v-if="infoModal.record.notes" class="mt-2">
			<strong>Notes</strong>
			<pre>{{ infoModal.record.notes }}</pre>
		</p>

	</modal-dialog>

	<modal-dialog v-if="conflictResolutionModal.visible"
		:modal-visible="conflictResolutionModal.visible"
		:submit-visible="false"
		title="Event Conflict"
		v-on:closeModal="conflictResolutionModal.visible = false">

		<p>{{ conflictResolutionModal.message }}</p>

		<p>Would you like to:</p>

		<ul>
			<li>Fit the new event in between the conflict event (this will crop the conflict event as necessary)</li>
			<li>Delete the conflict event entirely</li>
			<li>Cancel (do not add this new event)</li>
		</ul>

		<template slot="footer">
			<button type="button" class="btn btn-primary mr-1" v-on:click="cropConflictEvent">
				Fit in Between
			</button>
			<button type="button" class="btn btn-danger" style="text-transform: uppercase;" v-on:click="deleteConflictEvent">
				Delete Conflict Event
			</button>
		</template>

	</modal-dialog>

	<modal-dialog v-if="iconLegendModal.visible"
		:modal-visible="iconLegendModal.visible"
		:submit-visible="false"
		title="Icon Legend"
		cancel-button-text="Done"
		v-on:closeModal="iconLegendModal.visible = false">

		<ul style="list-style:none;">
			<li v-for="item in iconLegendModal.items" class="mb-1">
				<i class="fa fa-fw" :class="item.icon"></i>
				{{ item.label }}
			</li>
		</ul>

	</modal-dialog>
</div>
</template>
<script type="text/javascript">

import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"
import Accordion from "@/components/Accordion"
import EquipmentPicker from "@/components/equipment_picker/EquipmentPicker"
import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"
import FormGroup from "@/components/FormGroup"
import SearchBar from "@/components/SearchBar"
import Spinner from "@/components/Spinner"
import Alert from "@/components/Alert"
import JobPicker from "@/components/super_components/JobPicker"

import draggable from "vuedraggable"
import VueDraggableResizable from 'vue-draggable-resizable'

import WeeklyView from "@/components/schedule/WeeklyView.vue"
import MonthlyView from "@/components/schedule/MonthlyView.vue"
import ScheduleCardIndicators from "@/components/schedule/ScheduleCardIndicators"
import PublishControls from "@/components/schedule/PublishControls"

import ScheduleEventEditModal from "@/components/super_components/ScheduleEventEditModal"

import ContextMenu from "@/layout_fragments/ContextMenu"

import ScheduleMixins from "@/mixins/ScheduleMixins.js"

// optionally import default styles
//import 'vue-draggable-resizable/dist/VueDraggableResizable.css'

export default {
	name: "ScheduleComponent",
	components: {
		CollapsiblePanel,
		Accordion,
		EquipmentPicker,
		ModalDialog,
		Field,
		draggable,
		VueDraggableResizable,
		FormGroup,
		SearchBar,
		Spinner,
		WeeklyView,
		MonthlyView,
		Alert,
		ScheduleEventEditModal,
		ScheduleCardIndicators,
		PublishControls,
		ContextMenu,
		JobPicker
	},
	mixins: [ScheduleMixins],
	props: [
		"selectedDateExternal",
		"filtersExternal",
		"serviceId",
		"projectId"
	],
	data() {
		return {
			panelOpen: false,
			selectedDate: '',
			users: [],
			employeeListFilters: [],
			serviceListFilters: ['my-services'],
			projectListFilters: ['my-projects'],
			events: [],
			preloadedEvents: [],
			equipmentServices: [],
			scheduleEntities: [],
			scheduleRows: [],
			baseIncrementWidth: 75, //px
			itemHeight: 30,
			activeItemIndex: null,
			activeRowIndex: null,
			rand: Math.random(),
			itemModalEdit: {
				createRecord: false,
				visible: false,
				item: {},
				//formValues: {},
				userEventType: null,
				isLeadTechnician: false,
				repeatItem: {
					daysOfWeek: []
				}
			},
			infoModal: {
				visible: false,
				record: null,
				jobRecord: null
			},
			deleteModal: {
				visible: false,
				deleteRelated: false
			},
			sendNoticeConfirmModal: {
				working: false,
				visible: false
			},
			duplicateConfirmModal: {
				working: false,
				visible: false,
				relatedJobEvents: [],
				eventPayload: {}
			},
			iconLegendModal: {
				visible: false,
				items: [
					{
						icon: 'fa-chevron-left',
						label: "Event started earlier"
					},
					{
						icon: 'fa-wrench',
						label: "Equipment is scheduled for maintenance/servicing"
					},
					{
						icon: 'fa-ban',
						label: "User is scheduled OFF"
					},
					{
						icon: 'fa-umbrella-beach',
						label: "Vacation"
					},
					{
						icon: 'fa-first-aid',
						label: "Medical Leave"
					},
					{
						icon: 'fa-user-tie',
						label: "User is management lead"
					},
					{
						icon: 'fa-hard-hat',
						label: "User is operations lead"
					},
					{
						icon: 'fa-vest',
						label: "User is lead crew member"
					},
					{
						icon: 'fa-sticky-note',
						label: "This event has notes"
					}
				]
			},
			shiftsDisplay: 'full-day',
			employeeSearchTerms: "",
			projectSearchTerms: "",
			serviceSearchTerms: "",
			dragging: false,
			calendarView: 'daily',
			showFilterPanel: false,
			typeFiltering: false,
			projectFiltering: false,
			serviceFiltering: false,
			equipmentFiltering: false,
			userFiltering: false,
			droppableVisible: false,
			droppableOffVisible: false,
			filters: { 
				mainTypes: [],
				projectIds: [],
				serviceIds: [],
				equipmentIds: [],
				userIds: [],
				showOnlyRelated: false,
				mineOnly: false,
			},
			eventIncludes: [
				{
					model:"Equipment",
					fields:["id","slug","description","serial_num","type_id", "color_hex"],
					include: [
						{
							model: "EquipmentType",
							fields: ["color_hex"],
							include: [
								{
									model: "EquipmentCategory",
									fields: ["color_hex"]
								}
							]
						}
					]
				},
				{
					model:"User",
					fields:["id","slug","first_name","last_name"],
					include: [
						{
							model: "EmployeeSetting",
							fields: ["color_hex"]
						},
						{
							model: "EmployeeClassification",
							fields: ["color_hex"]
						}
					]
				},
				{
					model:"Service",
					fields:["id","slug","job_name","job_num","address","city","Customer","assigned_to","helper_techs_json"],
					include: [
						{
							model: "JobPersonnelRole",
							fields: ["personnel_role_id","title","abbreviation","user_id","is_field_ops_lead","is_management_lead"]
						},
						{
							model: "Contact",
							fields: ["name"]
						}
					]
				},
				{
					model:"Job",
					fields:["id","slug","job_name","job_num","address","city","Customer"],
					include: [
						{
							model: "JobPersonnelRole",
							fields: ["personnel_role_id","title","abbreviation","user_id","is_field_ops_lead","is_management_lead"]
						},
						{
							model: "Contact",
							fields: ["name"]
						}
					]
				}
			],
			scheduleRowsHeight: "",
			isTouchscreen: false,
			showScheduleControls: false
		}
	},
	watch: {
		selectedDateExternal() {
			this.initSelectedDate()
		},
		filtersExternal() {
			this.initFilters()
		},
		panelOpen() {
			this.$emit('panelToggle',this.panelOpen)
		},
		projectId() {
			if (this.projectId) {
				this.filters.projectIds = [this.projectId]
				this.projectFiltering = true
			}
		},
		serviceId() {
			if (this.serviceId) {
				this.filters.serviceIds = [this.serviceId]
				this.serviceFiltering = true
			}
		}
	},
	computed: {
		actionMenuButtons() {
			let buttons = []

			if (!this.dayIsPublished) {

				buttons.push({
					icon: 'fa-plus',
					text: 'Add to Schedule',
					clickFunction: 'addToSchedule'
				})

				buttons.push({
					icon: 'fa-paper-plane',
					text: 'Publish Day',
					clickFunction: "publishDay"
				})
			}
			else {
				buttons.push({
					icon: 'fa-plus',
					text: 'Add to Schedule',
					clickFunction: 'addToSchedule',
					disabled: true
				})

				buttons.push({
					icon: 'fa-pencil-alt',
					text: 'Un-publish Day',
					clickFunction: "unpublishDay"
				})

				buttons.push({
					icon: 'fa-paper-plane',
					text: 'Send Notices',
					clickFunction: "sendNotices"
				})
			}

			return buttons
		},
		viewMenuButtons() {
			let buttons = []

			if (window.innerWidth > 1000) {
				buttons.push({
					text: 'Daily View',
					clickFunction: "activateDailyView",
					disabled: this.calendarView == 'daily' ? true : false,
					icon: this.calendarView == 'daily' ? 'fa-check' : false
				})

				buttons.push({
					text: 'Weekly View',
					clickFunction: "activateWeeklyView",
					disabled: this.calendarView == 'weekly' ? true : false,
					icon: this.calendarView == 'weekly' ? 'fa-check' : false
				})

				buttons.push({
					text: 'Monthly View',
					clickFunction: "activateMonthlyView",
					disabled: this.calendarView == 'monthly' ? true : false,
					icon: this.calendarView == 'monthly' ? 'fa-check' : false
				})

				buttons.push({
					isDivider: true
				})
			}

			let dayShiftDisabled = this.shiftsDisplay == 'day-shift-only' ? true : false
			let fullDayDisabled = this.shiftsDisplay == 'full-day' ? true : false
			let nightShiftDisabled = this.shiftsDisplay == 'night-shift-only' ? true : false

			if (this.calendarView == 'daily') {
				buttons.push({
					icon: 'fa-sun',
					text: 'Day Shift Only',
					disabled: dayShiftDisabled,
					clickFunction: "activateDayShiftView"
				})

				buttons.push({
					icon: 'fa-arrows-alt-h',
					text: 'Full Day',
					disabled: fullDayDisabled,
					clickFunction: "activateFullDayView"
				})

				buttons.push({
					icon: 'fa-moon',
					text: 'Night Shift Only',
					disabled: nightShiftDisabled,
					clickFunction: "activateNightShiftView"
				})

				buttons.push({
					isDivider: true
				})
			}

			buttons.push({
				icon: 'fa-filter',
				text: 'Filter',
				disabled: this.showFilterPanel ? true : false,
				clickFunction: "openFilterPanel"
			})

			return buttons
		},
		calendarViewStateLabel() {
			let label = ""

			if (this.calendarView == 'daily') {
				label = "Daily View, "

				if (this.shiftsDisplay == 'day-shift-only')
					label += "showing Day Shift Only"
				if (this.shiftsDisplay == 'full-day')
					label += "showing Full Day"
				if (this.shiftsDisplay == 'night-shift-only')
					label += "showing Night Shift Only"
					
			}
			else if (this.calendarView == 'weekly')
				label = "Weekly View"
			else if (this.calendarView == 'monthly')
				label = "Monthly View"

			return label
		},
		selfUserEvents() {

			let name = this.$store.userDetails.first_name + " " + this.$store.userDetails.last_name

			return [
				{
					type: "user",
					label: "Vacation",
					description: "Vacation: " + name,
					is_vacation: 1,
					user_id: this.$store.userDetails.id,
					id: this.$store.userDetails.id,
					User: this.$store.userDetails
				},
				{
					type: "user",
					label: "Medical Leave",
					description: "Medical Leave: " + name,
					is_sickday: 1,
					user_id: this.$store.userDetails.id,
					id: this.$store.userDetails.id,
					User: this.$store.userDetails
				},
				{
					type: "user",
					label: "Generic Time Off",
					description: " Time Off: " + name,
					user_id: this.$store.userDetails.id,
					id: this.$store.userDetails.id,
					User: this.$store.userDetails
				}
			]
		},
		incrementWidth() {
			if (this.shiftsDisplay == 'full-day')
				return this.baseIncrementWidth/2

			return this.baseIncrementWidth
		},
		modifiedIncrementWidth() {
			if (this.shiftsDisplay == 'full-day')
				return this.incrementWidth * 2

			return this.incrementWidth
		},
		indicatorLineHeights() {
			let height = this.itemHeight * this.scheduleRows.length

			return height+"px"
		},
		dayDividerLineLeft() {
			let left = this.modifiedIncrementWidth * (this.dayLength - this.dayStart)

			return left + "px"
		},
		timeIndicatorLineLeft() {
			let currentHoursFromStartOfday = this.moment().diff(this.moment().startOf("day"),"minutes") / 60

			let left = this.incrementWidth * (currentHoursFromStartOfday - this.dayStart) * 2

			left = left - 15 //line has 30px thickness, so center it

			return left + "px"
		},
		scheduleHeading() {
			if (this.calendarView == 'daily')
				return this.moment(this.selectedDate).format("ddd MMM D, YYYY")

			else if (this.calendarView == 'weekly')
				return "Week of "+this.moment(this.selectedDate).startOf('week').format("MMM D, YYYY")

			else if (this.calendarView == 'monthly')
				return this.moment(this.selectedDate).format("MMM YYYY")

			return ""
		},
		timelineSizeButtons() {
			if (window.innerWidth > 1000) {
				return [
					{text: 'Day Shift Only',value:'day-shift-only',icon:'fa-sun'},
					{text: 'Full Day',value:'full-day'},
					{text: 'Night Shift Only',value:'night-shift-only',icon:'fa-moon'}
				]
			}
			else {
				return [
					{text: '',value:'day-shift-only',icon:'fa-sun'},
					{text: 'F',value:'full-day'},
					{text: '',value:'night-shift-only',icon:'fa-moon'}
				]
			}
		},
		calendarViewButtons() {
			if (window.innerWidth > 1000) {
				return [
					{text: 'Daily',value:'daily'},
					{text: 'Weekly',value:'weekly'},
					{text: 'Monthly',value:'monthly'}
				]
			}
			else {
				return [
					{text: 'M',value:'monthly'},
					{text: 'W',value:'weekly'},
					{text: 'D',value:'daily'}
				]
				
			}
		},
		calendarViewTimeRange() {
			let from,to

			if (this.calendarView == 'daily') {
				from = this.moment(this.selectedDate+" 00:00:00").add(this.dayStart,"hours")

				to = this.moment(from).add(this.dayLength,"hours").subtract(1,"seconds")
			}
			else if (this.calendarView == 'weekly') {
				from = this.moment(this.selectedDate).startOf('week').add(this.dayStart,"hours")
				to = this.moment(from).add(7,"days").subtract(1,"seconds")
			}
			else if (this.calendarView == 'monthly') {
				from = this.moment(this.selectedDate).startOf("month").add(this.dayStart,"hours")
				to = this.moment(from).add(1,"months").subtract(1,"seconds")
			}

			return {
				from,
				to
			}
		},
		dayIsPublished() {
			let vm = this

			//day is considered published if all events for the day are is_published = 1 on it
			//unpublishing the event will set is_published = 0 to all events on the day
			if (!this.scheduleRows)
				return false

			//check for any events that are not equipment-servicing events
			let hasEvents = false
			this.scheduleRows.forEach(row => {
				if ("items" in row && row.items && !hasEvents)
					hasEvents = row.items.find(event => event.type != 'equipment-servicing')
			})

			if (!hasEvents)
				return false

			let foundUnpublished = false
			this.scheduleRows.forEach(row => {
				if ("items" in row && row.items && !foundUnpublished) 
					foundUnpublished = row.items.find(event => event.is_published == 0 && event.type != 'equipment-servicing')
			})

			if (foundUnpublished)
				return false

			return true
		},
		numBlocks() {
			return this.dayLength / this.scheduleIncrement
		},
		scheduleWidth() {
			let width = this.numBlocks * this.incrementWidth

			return width+"px"
		},
		scheduledEquipmentWithTotalHours() {
			let vm = this

			let equipment = []

			let equipmentEvents = this.events.filter(event => event.equipment_id > 0).forEach(event => {
				if (event.Equipment && !equipment.find(eq => eq.id == event.Equipment.id))
					equipment.push(event.Equipment)
			})

			equipment = equipment.map(eq => {
				eq.totalHrsScheduled = vm.events.filter(event => event.equipment_id == eq.id).reduce((acc,event) => {
					return acc + vm.moment(event.end_time).diff(event.start_time,"hours")
				},0)

				eq.attachedData = "<span class='badge badge-primary'>"+eq.totalHrsScheduled.toFixed(1)+" hrs</span>"

				return eq
			})

			return equipment
		},
		mutatedUsers() {
			let vm = this

			let filteredUsers = this.users
			if (this.employeeSearchTerms) {

				let lowerCaseTerms = this.employeeSearchTerms.toLowerCase()

				filteredUsers = filteredUsers.filter(user => {
					if (user.first_name.toLowerCase().indexOf(lowerCaseTerms) >= 0)
						return true
					else if (user.last_name.toLowerCase().indexOf(lowerCaseTerms) >= 0)
						return true

					return false
				})
			}

			if (this.employeeListFilters.indexOf("hide-salaried-employees") >= 0)  
				filteredUsers = filteredUsers.filter(user => !("EmployeeSetting" in user) || !user.EmployeeSetting || user.EmployeeSetting.length == 0 || user.EmployeeSetting[0].is_salary == 0)

			if (this.employeeListFilters.indexOf("only-unscheduled") >= 0) 
				filteredUsers = filteredUsers.filter(user => this.calcHoursScheduled(user,'user_id') == 0)

			return filteredUsers.map(user => {
				user.description = user.first_name+" "+user.last_name
				user.type = "user"

				let userTimeOffEvents = vm.events.filter(event => 
						event.user_id == user.id && //user matches
						( //sickday or approved vacation
							(event.is_vacation == 1 && event.approved_by > 0) || event.is_sickday == 1
						) 
					)

				if (userTimeOffEvents.length > 0)
					user.hasTimeOffScheduled = true
				else
					user.hasTimeOffScheduled = false

				let userEvents = vm.events
					.filter(event => event.user_id == user.id && vm.moment(event.start_time).format("YYYY-MM-DD") == vm.selectedDate)
					.reduce((acc,event) => {
						let eventString = ""
						if (event.Service)
							eventString += "Service #"+event.Service.job_num
						else if (event.Job)
							eventString += "Project #"+event.Job.job_num
						else if (event.is_vacation == 1)
							eventString += "Vacation"
						else if (event.is_sickday == 1)
							eventString += "Medical Leave"
						else
							eventString += "Other Event"

						eventString += " "+vm.moment(event.start_time).format("HH:mm A")+" to "+vm.moment(event.end_time).format("HH:mm A")

						return acc + eventString+"\n"
					},"")

				user.tooltip = "Schedule events:\n"+userEvents

				return user
			})
		},
		mutatedServices() {
			let vm = this

			let jobs = this.$store.services.map(job => {

				if ("Customer" in job && job.Customer)
					job.description = job.job_num + ": " + job.Customer.name
				else if ("customer_name_cache" in job)
					job.description = job.job_num + ": " + job.customer_name_cache
				else
					job.description = job.job_num

				job.type = "service"

				return job
			})

			let filteredJobs = jobs
			if (this.serviceSearchTerms) 
				filteredJobs = vm.filterJobsToSearchTerms(this.serviceSearchTerms,jobs)

			if (this.serviceListFilters.indexOf("only-unscheduled") >= 0) 
				filteredJobs = filteredJobs.filter(job => this.calcHoursScheduled(job,'service_id') == 0)

			if (this.serviceListFilters.indexOf("my-services") >= 0) {
				filteredJobs = filteredJobs.filter(job => {
					let found = false

					if ("User" in job && job.User) 
						found = job.User.find(user => user.id == vm.$store.userDetails.id)
					
					if (found)
						return true

					let helperIds = []
					try {
						helperIds = JSON.parse(job.helper_techs_json)
					}
					catch (ex) {}

					return helperIds.indexOf(vm.$store.userDetails.id) >= 0
				})
			}

			return filteredJobs
		},
		mutatedProjects() {
			let vm = this

			let jobs = []

			if (this.$store.projects) {
				jobs = this.$store.projects.map(job => {
					job.description = job.job_num+": "+job.job_name
					job.type = "project"

					return job
				})
			}

			let filteredJobs = jobs

			if (this.projectSearchTerms)
				filteredJobs = vm.filterJobsToSearchTerms(this.projectSearchTerms,jobs)

			if (this.projectListFilters.indexOf("only-unscheduled") >= 0) 
				filteredJobs = filteredJobs.filter(job => this.calcHoursScheduled(job,'job_id') == 0)

			if (this.projectListFilters.indexOf("my-projects") >= 0) {
				filteredJobs = filteredJobs.filter(job => {
					let found = false

					if ("User" in job && job.User) 
						found = job.User.find(user => user.id == vm.$store.userDetails.id)
					
					return found
				})
			}

			return filteredJobs
		},
		projectsOnSchedule() {
			let jobs = []
			this.events.forEach(event => {
				if ("Job" in event && event.Job && event.equipment_id == 0 && event.user_id == 0)
					jobs.push(event.Job)
			})

			return jobs
		},
		servicesOnSchedule() {
			let jobs = []
			this.events.forEach(event => {
				if ("Service" in event && event.Service && event.equipment_id == 0 && event.user_id == 0)
					jobs.push(event.Service)
			})
			return jobs
		},
		timeBlocks() {
			let vm = this
			let blocks = []
			for (var i = this.dayStart; i < this.dayLength + this.dayStart; i += this.scheduleIncrement) 
				blocks.push(this.formatTimeBlock(i))

			return blocks
		},
		droppableBlocks() {
			let vm = this

			let blocks = []
			for (var i = 0; i < this.dayLength; i += this.scheduleIncrement) {
				blocks.push({
					startTime: i
				})
			}

			return blocks
		},
		employeesOnSchedule() {
			let employees = []
			this.events.forEach(event => {
				if ("User" in event && event.User && !employees.find(user => user.id == event.User.id)) 
					employees.push(event.User)
			})

			return employees
				.map(user => {
					user.displayField = user.first_name+" "+user.last_name
					return user
				})
				.sort((a,b) => (a.displayField > b.displayField) ? 1 : -1)
		}
	},
	methods: {
		close() {	
			//top calculation of shedule container doesn't update correctly when multi-selects are opened, then closed, resulting in an incorrect container height. $nextTick() doesn't seem to solve the problem, only a setTimeout with a 300ms+ does
			setTimeout(() => {
				this.$forceUpdate()
			},300)
		},
		initFilters() {
			this.initTypeFilterValues()

			if (this.projectId) {
				this.filters.projectIds = [this.projectId]
				this.filters.mainTypes = ["project","equipment","user"]
				this.projectFiltering = true
				this.filters.showOnlyRelated = true
			}

			if (this.serviceId) {
				this.filters.serviceIds = [this.serviceId]
				this.filters.mainTypes = ["service","equipment","user"]
				this.serviceFiltering = true
				this.filters.showOnlyRelated = true
			}

			if (this.filtersExternal) {
				this.filters = this.filtersExternal

				if (this.filters.serviceIds.length > 0)
					this.serviceFiltering = true

				if (this.filters.projectIds.length > 0)
					this.projectFiltering = true

				if (this.filters.equipmentIds.length > 0)
					this.equipmentFiltering = true

				if (this.filters.userIds.length > 0)
					this.userFiltering = true
			}

			if (this.filters.mainTypes.length > 0) 
				this.typeFiltering = true

			if (!this.hasModulePermRead("Schedule")) {
				this.filters.mineOnly = true
				this.fetchMyJobs()
			}
		},
		initView() {
			let views = ["daily","weekly","monthly"]

			if ("view" in this.$route.params && this.$route.params.view && views.indexOf(this.$route.params.view) >= 0)
				this.calendarView = this.$route.params.view
		},
		initSelectedDate() {
			if ("date" in this.$route.params && this.$route.params.date && this.moment(this.$route.params.date).isValid())
				this.selectedDate = this.moment(this.$route.params.date).format("YYYY-MM-DD")
			else if (this.selectedDateExternal)
				this.selectedDate = this.selectedDateExternal
			else
				this.selectedDate = this.moment().format("YYYY-MM-DD")
		},
		initScheduleEntities() {
			this.scheduleEntities = []
			for (var i = 0; i <= this.dayLength; i += this.scheduleIncrement)
				this.scheduleEntities.push([])
			
		},
		initTypeFilterValues() {
			this.filters.mainTypes = ["project","service","equipment","user","equipment-servicing"]
		},
		scrollToCurrentTime() {
			let scrollElement = this.$refs.dayView

			let currentHour = this.moment().format("HH")

			let hourFromDayStart = currentHour - this.dayStart

			let scrollIncrement = this.baseIncrementWidth

			if (this.shiftsDisplay != 'full-day')
				scrollIncrement = scrollIncrement * 2


			let scrollLeft = hourFromDayStart * scrollIncrement

			scrollElement.scrollLeft = scrollLeft
		},
		setScheduleUrl() {
			if (!this.projectId && !this.serviceId)
				//only set url if we're not in a jobs module
				window.history.pushState({},"","/schedule/"+this.calendarView+"/"+this.selectedDate)
		},
		setScheduleRowsHeight() {
			let vm = this

			this.$nextTick(() => {
				let scheduleRowsEl = document.querySelector(".day-view-inner")

				let offsetTop = 0
				if (scheduleRowsEl) {
					let offset = this.offset(scheduleRowsEl)

					offsetTop = offset.top + 47

					if (this.panelOpen)
						offsetTop += (vm.itemHeight * 2)
				}

				if (this.projectId || this.serviceId)
					offsetTop += 110

				this.scheduleRowsHeight = "calc(100vh - "+offsetTop+"px)"
			})
		},
		setScheduleGridHeight() {
			this.$nextTick(() => {
				let scheduleGridEl = document.querySelector(".schedule-grid")

				let offsetTop = 0
				if (scheduleGridEl) {

					let offset = this.offset(scheduleGridEl)
					offsetTop = offset.top  + 2
				}

				this.scheduleGridHeight = "calc(100vh - "+offsetTop+"px)"
			})
		},
		filterJobsToSearchTerms(searchTerms,jobs) {
			let lowerCaseTerms = searchTerms.toLowerCase()

			let baseFieldSearches = ["job_num","job_name","address","city","postal_code"]

			return jobs.filter(job => {
				let found = false
				baseFieldSearches.forEach(field => {
					if (job[field] && job[field].toLowerCase().indexOf(lowerCaseTerms) >= 0)
						found = true
				})

				if (found)
					return true
				else if ("Customer" in job && job.Customer && job.Customer.name.toLowerCase().indexOf(lowerCaseTerms) >= 0)
					return true

				return false
			})
		},
		typeFilterToggleChange(value) {
			if (value == 0)
				this.initTypeFilterValues()
		},
		decrementSelectedDate() {
			if (this.calendarView == 'daily')
				this.selectedDate = this.moment(this.selectedDate).subtract(1,"days").format("YYYY-MM-DD")
			else if (this.calendarView == 'weekly')
				this.selectedDate = this.moment(this.selectedDate).subtract(7,"days").format("YYYY-MM-DD")
			else if (this.calendarView == 'monthly')
				this.selectedDate = this.moment(this.selectedDate).subtract(1,"months").format("YYYY-MM-DD")

			this.setScheduleUrl()

			this.debounce("fetchAllEvents",true,1000)
		},
		incrementSelectedDate() {
			if (this.calendarView == 'daily') {
				this.selectedDate = this.moment(this.selectedDate).add(1,"days").format("YYYY-MM-DD")
			}
			else if (this.calendarView == 'weekly')
				this.selectedDate = this.moment(this.selectedDate).add(7,"days").format("YYYY-MM-DD")
			else if (this.calendarView == 'monthly')
				this.selectedDate = this.moment(this.selectedDate).add(1,"months").format("YYYY-MM-DD")

			this.setScheduleUrl()

			this.debounce("fetchAllEvents",true,1000)
		},
		daySelected(dateString) {
			this.selectedDate = dateString
			this.calendarView = 'daily'

			this.setScheduleUrl()

			this.fetchAllEvents(true)
		},
		activateNightShiftView() {
			this.shiftsDisplay = "night-shift-only"
			this.toggleShiftsDisplay(this.shiftsDisplay)
		},
		activateDayShiftView() {
			this.shiftsDisplay = 'day-shift-only'
			this.toggleShiftsDisplay(this.shiftsDisplay)
		},
		activateFullDayView() {
			this.shiftsDisplay = 'full-day'
			this.toggleShiftsDisplay(this.shiftsDisplay)
		},
		openFilterPanel() {
			this.showFilterPanel = true
		},
		calendarViewChange(value) {
			let vm = this
			
			if (value != 'daily')
				vm.panelOpen = false

			if (value == 'monthly') {
				//default filters down to only projects/services
				this.typeFiltering = true
				this.filters.mainTypes = ["project","service"]
			}
			else {
				//default filters to all for daily/weekly
				this.typeFiltering = true
				this.filters.mainTypes = ["project","service","equipment","equipment-servicing","user"]
			}

			this.setScheduleUrl()

			this.$nextTick(() => {

				if (value == 'monthly' && vm.preloadedEvents.length > 0) {
					vm.fetchEquipmentServices().then(response => {
						if (response.success) {
							vm.events = vm.preloadedEvents
							vm.scheduleRows = vm.renderScheduleRows(vm.preloadedEvents,vm.equipmentServices)	
						}
					})
				}
				else
					vm.fetchAllEvents(true)

				if (value == 'daily') {
					if (this.shiftsDisplay == 'full-day')
						this.dayStart = 0
					//vm.scrollToCurrentTime()
				}
				else
					this.dayStart = 6
			})
		},
		filterMainTypeChange(value) {
			let vm = this

			if (this.filters.mainTypes.indexOf('equipment-servicing') >= 0 && this.equipmentServices.length == 0)
				this.fetchEquipmentServices()

			this.$nextTick(() => {
				vm.scheduleRows = vm.renderScheduleRows(vm.events,vm.equipmentServices)
			})
		},
		mineOnlyChange(value) {
			if (value && (this.$store.userServiceIds.length == 0 || this.$store.userProjectIds.length == 0))
				this.fetchMyJobs()
		},
		setActiveItemIndexes(rowIndex,itemIndex) {
			this.activeItemIndex = itemIndex
			this.activeRowIndex = rowIndex
		},
		addToSchedule() {
			this.panelOpen = true

			if (this.calendarView != 'daily') {
				this.calendarView = 'daily'
				this.calendarViewChange("daily")
			}
		},
		hasOverLap(item1,item2) {
			if (item1.startMoment.isSameOrBefore(item2.startMoment) && item1.endMoment.isAfter(item2.startMoment))
				return true
			else if (item1.startMoment.isBefore(item2.endMoment) && item1.startMoment.isSameOrAfter(item2.startMoment))
				return true
			if (item2.startMoment.isSameOrBefore(item1.startMoment) && item2.endMoment.isAfter(item1.startMoment))
				return true
			else if (item2.startMoment.isBefore(item1.endMoment) && item2.startMoment.isSameOrAfter(item1.startMoment))
				return true
				
			return false
		},
		hasConflict(item) {
			let vm = this
			return this.scheduleRows[this.activeRowIndex].items.find((otherItem,index) => {
				if (index != vm.activeItemIndex)  
					return this.hasOverLap(otherItem,item)
			
				return false
			})	
		},
		formatTimeBlock(i) {
			if (i > 24)
				i = i % 24 //get remainder, which gives us hour rollover

			let hrs = Math.floor(i)
			
			let amPm = " PM"
			if (hrs < 12 || hrs >= 24)
				amPm = " AM"

			let min = (i - hrs) * 60
			let minFixed
			if (min < 10)
				minFixed = "0"+min
			else
				minFixed = String(min)

			if (hrs > 12)
				hrs -= 12

			let hrsFixed = hrs

			return hrsFixed+":"+minFixed+amPm
		},
		eventStartEndTimeFormatted(startMoment,endMoment) {
			if (endMoment.diff(startMoment,"hours") <= 24) 
				return startMoment.format("MMM D @ h:mm a")+" to "+endMoment.format("h:mm a")
			else 
				return startMoment.format("MMM D @ h:mm a")+" to "+endMoment.format("MMM D @ h:mm a")
		},
		calcHoursScheduled(entity,entity_key,selectedDate = false) {
			let vm = this

			let hours = this.events
				.filter(event => event[entity_key] == entity.id && event.is_vacation == 0 && event.is_sickday == 0)
				.filter(event => !selectedDate || selectedDate == vm.moment.utc(event.start_time).local().format("YYYY-MM-DD"))
				.filter(event => 
					((entity.type == 'project' || entity.type == 'service') && event.user_id == 0 && event.equipment_id == 0) ||
					(entity.type == 'user' && event.user_id > 0) || 
					(entity.type == 'equipment' && event.equipment_id > 0)
				)
				.reduce((acc,event) => acc + vm.moment.utc(event.end_time).local().diff(vm.moment.utc(event.start_time).local(),"hours"),0)

			return hours.round(1)
		},
		calcMomentFromIndex(index) {
			return this.moment(this.selectedDate + " 00:00:00").add(this.dayStart + (index * this.scheduleIncrement),"hours")
		},
		calcMomentFromX(x) {
			return this.calcMomentFromIndex(x / this.incrementWidth)
		},
		calcDurationFromWidth(width) {
			return width / this.incrementWidth * this.scheduleIncrement
		},
		calcBlockWidthFromDuration(duration) {
			return duration * this.incrementWidth / this.scheduleIncrement
		},
		calcItemAdjustedX(startMoment) {
			let index = this.calcIndexFromMoment(startMoment,this.selectedDate)

			if (index < 0)
				return 0

			return index * this.incrementWidth
		},
		calcItemAdjustedWidth(item) {
			let index = this.calcIndexFromMoment(item.startMoment,this.selectedDate)

			let duration = 0
			if ("duration" in item)
				duration = item.duration
			else 
				duration = item.endMoment.diff(item.startMoment,"hours")

			let rawWidth = this.calcBlockWidthFromDuration(duration)

			let finalWidth = 0

			if (index < 0) {
				//event starts before the currently selected day, so we need know how much the offset is so we can trim that off the width
				let offset = index * this.incrementWidth //this will be a negative number

				finalWidth = rawWidth + offset //offset is negative, so we're actually subtracting from width here
			}
			else 
				finalWidth = rawWidth

			if (finalWidth < 0)
				return 1

			return finalWidth
			
		},
		toggleShiftsDisplay(value) {
			if (value == 'full-day') {
				this.dayLength = 24
				this.dayStart = 0
			}
			else if (value == 'day-shift-only') {
				this.dayLength = 12
				this.dayStart = 6
			}
			else if (value == 'night-shift-only') {
				this.dayLength = 12
				this.dayStart = 18
			}

			this.rand = Math.random()
			this.$forceUpdate()
		},
		createChangedItem(x,width) {
			let item = this.filterRenderedScheduleRows(this.scheduleRows)[this.activeRowIndex].items[this.activeItemIndex]

			let duration = item.duration
			if (width)
				duration = this.calcDurationFromWidth(width)

			let newStartMoment = this.calcMomentFromX(x)
			let newEndMoment = this.moment(newStartMoment).add(duration,"h")

			let newItem = this.cloneObj(item)
			newItem.startMoment = newStartMoment
			newItem.endMoment = newEndMoment
			newItem.startIndex = this.calcIndexFromMoment(newItem.startMoment,this.selectedDate)
			newItem.duration = duration

			return newItem
		},
		sniffTypeFromItemProperties(item) {
			if ("first_name" in item)
				return "user"
			else if ("date_acquired" in item && "type_id" in item)
				return "equipment"
			else if ("is_internal_project" in item)
				return "project"
			else if ("due_date" in item || "appointment_time" in item || "estimated_time" in item || "helper_techs_json" in item)
				return "service"
		},
		updateScheduleRows(rows) {
			this.scheduleRows = rows
		},
		dragChoose() {
			this.dragging = true
		},
		dragCancel() {
			this.dragging = false
		},
		createScheduleItem(obj,parentEventOrIndex,additionalProperties) {
			
			if ( !("type" in obj)) 
				obj.type = this.sniffTypeFromItemProperties(obj)

			if (obj.type == "project") 
				obj.job_id = obj.id
			else if (obj.type == 'service')
				obj.service_id = obj.id
			else if (obj.type == 'user') {
				if ("id" in obj)
					obj.user_id = obj.id
				else
					obj.user_id = obj.user_id
			}
			else if (obj.type == 'equipment')
				obj.equipment_id = obj.id

			delete obj.id

			if (typeof parentEventOrIndex == 'object') {
				obj.duration = parentEventOrIndex.duration
				obj.startMoment = parentEventOrIndex.startMoment
				obj.endMoment = parentEventOrIndex.endMoment
			}
			else {

				let startHour
				if ("is_off" in obj && obj.is_off) {
					obj.duration = 23.99 - this.dayStart
					startHour = this.dayStart
				}
				else {
					obj.duration = 3

					startHour = this.dayStart + (parentEventOrIndex * this.scheduleIncrement)
				}
				obj.startMoment = this.moment(this.selectedDate+" 00:00:00").add(startHour,"hours")
				obj.endMoment = this.moment(obj.startMoment).add(obj.duration,"h")
			}

			if (obj.type == 'project' || obj.type == 'service')
				obj.repeat_until = obj.startMoment.format("YYYY-MM-DD")

			obj.startIndex = this.calcIndexFromMoment(obj.startMoment,this.selectedDate)

			if ("job_num" in obj && "job_name" in obj)
				obj.description = obj.job_num + ": " + obj.job_name

			obj.shortDescription = this.shortenDescription(obj.description,obj.duration)

			//append additionalProperties to object
			if (additionalProperties) {
				Object.keys(additionalProperties).forEach(key => {
					obj[key] = additionalProperties[key]
				})
			}
			//check to see if they already have a row
			let row = this.scheduleRows.find(row => {
				if (!("items" in row) || !row.items)
					return false

				return row.items.find(item => obj.type == item.type && item.id == obj.id)
			})

			/*
			if (row) 
				row.items.push(obj)
			else {
				//move to their own column
				this.scheduleRows.push({
					type: obj.type,
					entity_id: obj.id,
					items: [obj]
				})
			}
			*/

			this.initScheduleEntities()

			return obj
		},
		convertScheduleItemToPayload(item) {
			let payload = {
				start_time: item.startMoment.utc().format("YYYY-MM-DD HH:mm"),
				end_time: item.endMoment.utc().format("YYYY-MM-DD HH:mm"),
			}

			let mapKeys = ["user_id","equipment_id","service_id","job_id","event_id","notes","is_vacation","is_sickday","is_off"]
			mapKeys.forEach(key => {
				if (key in item && item[key] > 0)
					payload[key] = item[key]
			})

			//map the item id to the appropriate foreign key if its not already set
			let typeKeyMap = {
				service: "service_id",
				project: "job_id",
				user: "user_id",
				equipment: "equipment_id"
			}
			if (!(typeKeyMap[item.type] in payload))
				payload[typeKeyMap[item.type]] = item.id

			//make sure services that are linked to projects (which would have both job_id and service_id set), get the job_id removed
			if ("service_id" in payload && payload.service_id > 0)
				delete payload.job_id

			return payload
		},
		dragStart(event,isEmployee) {
			this.droppableVisible = true

			if (isEmployee)
				this.droppableOffVisible = true
		},
		dragEnd(event) {
			this.droppableVisible = false
			this.droppableOffVisible = false
		},
		dropped(event,index) {
			let vm = this

			if ("added" in event) {

				let item = this.createScheduleItem(this.cloneObj(event.added.element),index)

				if (item.user_id > 0 || item.equipment_id > 0) {
					//this was dropped into standalone slot, remove any service_id or job_id
					delete item.service_id
					delete item.job_id
				}

				this.saveEvent(this.convertScheduleItemToPayload(item)).then(response => {
					if (response.success) {
						vm.fetchScheduleEvents()
						item.id = response.data.record_id
						vm.editItem(item)
					}
				})
			}
		},
		droppedIntoJob(event,jobItem) {
			let vm = this

			let additionalProperties = {}, jobKey
			if (jobItem.type == 'project') 
				jobKey = "job_id"
			else if (jobItem.type == 'service') 
				jobKey = "service_id"

			additionalProperties[jobKey] = jobItem[jobKey]

			let item = this.createScheduleItem(event.item._underlying_vm_,jobItem,additionalProperties)

			let payload = this.convertScheduleItemToPayload(item)

			payload.parent_event_id = jobItem.id

			this.saveEvent(payload).then(response => {
				if (response.success) {

					//check if this job has duplicated events
					vm.fetchRelatedJobEvents(jobKey,additionalProperties[jobKey],true).then(response => {
						if (response.success && response.data.length > 1) {

							vm.duplicateConfirmModal.visible = true
							vm.duplicateConfirmModal.relatedJobEvents = response.data
							vm.duplicateConfirmModal.eventPayload = payload
						}
						else
							vm.fetchScheduleEvents()
					})

					//vm.fetchScheduleEvents()
				}
				else {
					//conflict, open modal for manual editing
					vm.editItem(item)

				}
			})
		},
		droppedIntoOff(event) {
			let vm = this
			let user = this.cloneObj(this.mutatedUsers[event.oldIndex])

			user.is_off = 1

			let item = this.createScheduleItem(user,0)

			this.saveEvent(this.convertScheduleItemToPayload(item)).then(response => {
				if (response.success) {
					vm.fetchScheduleEvents()
					item.id = response.data.record_id
					vm.editItem(item)
				}
			})
			
		},
		changeItemStartEnd(x,y,width,height) {
			let vm = this

			let newItem = this.createChangedItem(x,width)

			if (this.hasConflict(newItem)) {
				this.alertFail("This would conflict with another schedule block",true)
				this.rand = Math.random()
			}
			else {
				this.scheduleRows[this.activeRowIndex].items[this.activeItemIndex] = newItem

				this.saveEvent({
					id: newItem.id,
					start_time: newItem.startMoment.utc().format("YYYY-MM-DD HH:mm"),
					end_time: newItem.endMoment.utc().format("YYYY-MM-DD HH:mm")
				}).then(response => {
					//update position of cards, because there could be duplicated cards that need to be repositioned
					vm.fetchAllEvents()

					vm.activeRowIndex = null
					vm.activeItemIndex = null
				})
			}
		},
		entityAddClick(type,item) {
			this.itemModalEdit.visible = true
			this.itemModalEdit.createRecord = true

			if (item.type == 'equipment') {
				this.itemModalEdit.item = {
					job_id: 0,
					service_id: 0,
					start_time: "0000-00-00 00:00:00",
					end_time: "0000-00-00 00:00:00",
				}
			}
			else {
				item.type = type

				if (type == 'user') {
					item.job_id = 0
					item.service_id = 0
				}

				this.dropped({added: {element: item}},0)
			}
		},
		eventDeleted() {

			if (this.scheduleRows && this.scheduleRows.length >= this.activeRowIndex + 1 && this.scheduleRows[this.activeRowIndex] && "items" in this.scheduleRows[this.activeRowIndex]) {
				this.scheduleRows[this.activeRowIndex].items.splice(this.activeItemIndex,1)

				if (this.scheduleRows[this.activeRowIndex].items.length == 0)
					this.scheduleRows.splice(this.activeRowIndex,1)
			}

			this.activeItemIndex = null
			this.activeRowIndex = null

			this.fetchScheduleEvents()
		},
		eventSaved() {
			this.activeItemIndex = null
			this.activeRowIndex = null
			this.fetchScheduleEvents()
		},
		cropConflictEvent() {
			let vm = this
			let conflictEvent = this.conflictResolutionModal.conflictEvent
			let newEvent = this.conflictResolutionModal.newEventPayload

			let promises = []

			let payload = {
				id: conflictEvent.id
			}

			if (this.moment(conflictEvent.start_time).isBefore(this.moment(newEvent.start_time))) {
				//new event starts after conflict event, so conflict event end time needs to be set to new event start time
				payload.end_time = newEvent.start_time

				promises.push(this.postData("ScheduleEvent/save",payload))

				if (this.moment(conflictEvent.end_time).isAfter(this.moment(newEvent.end_time))) {
					//new event ends before conflict event ends, so we need to create a second event for the conflict event that pics up after the new event finishes
					payload = {
						start_time: newEvent.end_time,
						end_time: conflictEvent.end_time,
					}

					let copyFields = ["user_id","equipment_id","job_id","service_id","is_sickday","is_vacation","is_off","notes","starting_location","parent_event_id"]
					copyFields.forEach(key => {
						if (key in conflictEvent)
							payload[key] = conflictEvent[key]

					})

					promises.push(this.postData("ScheduleEvent/save",payload))
				}
			}
			else if (this.moment(conflictEvent.start_time).isSameOrAfter(this.moment(newEvent.start_time)) && this.moment(conflictEvent.end_time).isSameOrBefore(this.moment(newEvent.end_time))) {
				//new event eclipses conflict event, so just delete the conflict event
				promises.push(vm.postData("ScheduleEvent/delete",{id: this.conflictResolutionModal.conflictEvent.id}))
			}
			else {
				//new event starts before conflict event, so only start time of conflict event needs to be pushed back
				payload.start_time = newEvent.end_time

				promises.push(this.postData("ScheduleEvent/save",payload))
			}

			Promise.all(promises).then(responses => {
				let anyFailed = responses.find(response => !response.success)

				if (!anyFailed) {
					//now re-save the new event
					vm.postData("ScheduleEvent/save",newEvent).then(response => {
						if (response.success) {
							vm.conflictResolutionModal.visible = false
							vm.alertSuccess("The conflict event was cropped and your new event was inserted into the schedule")
						}
						else {
							vm.conflictResolutionModal.visible = false
							vm.alertFail("There are too many conflict events to modify. Please manually modify the schedule")
						}
						vm.fetchScheduleEvents()
					})
				}
			})
		},
		deleteConflictEvent() {
			let vm = this

			vm.postData("ScheduleEvent/delete",{id: this.conflictResolutionModal.conflictEvent.id},true).then(response => {
				if (response.success) {
					vm.postData("ScheduleEvent/save",this.conflictResolutionModal.newEventPayload).then(response => {
						if (response.success) {
							vm.conflictResolutionModal.visible = false
							vm.alertSuccess("The conflic event was deleted, and the new event was inserted into the schedule")
							vm.fetchScheduleEvents()
						}
					})
				}
			})
		},
		editFromDaily(rowIndex,itemIndex) {

			let item = this.filterRenderedScheduleRows(this.scheduleRows)[rowIndex].items[itemIndex]

			if (item.type == 'equipment-servicing')
				this.$router.push("/equipment/edit/"+item.equipmentSlug+"/log")

			else {
				this.activeRowIndex = rowIndex
				this.activeItemIndex = itemIndex

				this.editItem(item)
			}
		},
		editItem(item) {
			if (!this.dayIsPublished && item.type != 'equipment-servicing') {

				let vm = this
				this.itemModalEdit.visible = true

				this.itemModalEdit.item = item

				//find the active rowIndex and set it
				this.scheduleRows.forEach((row,rowIndex) => {
					if ("items" in row && row.items) {
						let itemIndex = row.items.findIndex(rowItem => rowItem.id == item.id)
						if (itemIndex >= 0) {
							vm.activeItemIndex = itemIndex
							vm.activeRowIndex = rowIndex
						}
					} 
				})

				/*
				this.itemModalEdit.formValues = {
					startDate: item.startMoment.local().format("YYYY-MM-DD"),
					startTime: item.startMoment.local().format("HH:mm"),
					endDate: item.endMoment.local().format("YYYY-MM-DD"),
					endTime: item.endMoment.local().format("HH:mm"),
					repeat_until: item.repeat_until,
					starting_location: item.starting_location,
					notes: item.notes
				}
				*/

				if (this.itemModalEdit.item.type == 'user') {

					if (this.itemModalEdit.item.isVacation == 1 || this.itemModalEdit.item.is_vacation == 1)
						this.itemModalEdit.userEventType = 'vacation'
					else if (this.itemModalEdit.item.isSickday == 1 || this.itemModalEdit.item.is_sickday == 1)
						this.itemModalEdit.userEventType = 'sick'
					else if (this.itemModalEdit.item.job_id > 0 || this.itemModalEdit.item.service_id > 0)
						this.itemModalEdit.userEventType = 'assignment'
					else
						this.itemModalEdit.userEventType = 'other'
				}

				/*
				let mapKeys = ["user_id","equipment_id","service_id","job_id"]
				mapKeys.forEach(key => {
					if (item[key] > 0)
						this.itemModalEdit.formValues[key] = item[key]
				})

				if (this.itemModalEdit.item.type == 'user' && "service_id" in this.itemModalEdit.formValues && this.itemModalEdit.formValues.service_id > 0) {
					//check if this user is the lead

				}
				*/
			}
			else if (item.type != 'equipment-servicing') {
				//open information modal on event

				
				this.infoModal.record = item

				if ("Job" in item && item.Job)
					this.infoModal.jobRecord = item.Job
				else if ("Service" in item && item.Service) 
					this.infoModal.jobRecord = item.Service
				else
					this.infoModal.jobRecord = null

				this.infoModal.visible = true
				
				//this.alertInfo("You need to un-publish the day to edit this event",true)
			}
		},
		publishUnpublishDay(publish) {
			let promises = [], vm = this

			if (this.calendarView == 'daily') {

				this.scheduleRows.forEach(row => {
					if ("items" in row) {
						row.items.forEach(item => {
							if (item.is_published == !publish) {
								let payload = {
									id: item.id,
									is_published: publish
								}

								promises.push(vm.postData("ScheduleEvent/save",payload))
							}
						})
					}
				})

				Promise.all(promises).then(responses => {

					let someFailed = responses.find(response => !response.success)

					if (!someFailed) {
						//set published status on all events
						vm.scheduleRows.forEach(row => {
							if ("items" in row) {
								row.items.forEach(item => {
									item.is_published = publish
								})
							}
						})

						if (publish) {
							vm.panelOpen = false
						}

						//add schedule log entry
						vm.postData("ScheduleLog/save",{
							action_type: publish ? 'published' : 'un-published',
							schedule_date : vm.selectedDate
						})
					}
				})
			}
		},
		confirmSendNotices() {
			let vm = this

			this.sendNoticeConfirmModal.working = true

			this.postData("ScheduleEvent/send-notices",{date: this.selectedDate}).then(response => {
				vm.sendNoticeConfirmModal.working = false

				if (response.success) {
					vm.sendNoticeConfirmModal.visible = false

					vm.postData("ScheduleLog/save",{
						action_type: "send-notice",
						schedule_date : vm.selectedDate
					})
				}
			})
		},
		confirmDuplicateEvent() {
			let vm = this

			this.duplicateConfirmModal.working = true
			
			let promises = []

			this.duplicateConfirmModal.relatedJobEvents.forEach(jobEvent => {

				let payload = {}

				let keysToCopy = ["user_id","equipment_id","job_id","service_id"]
				keysToCopy.forEach(key => {
					if (key in vm.duplicateConfirmModal.eventPayload)
						payload[key] = vm.duplicateConfirmModal.eventPayload[key]
				})

				//keep time, change date
				let jobStartTime = vm.moment(jobEvent.start_time)
				let eventStartTime = vm.moment(vm.duplicateConfirmModal.eventPayload.start_time)
				payload.start_time = jobStartTime.format("YYYY-MM-DD") + " " + eventStartTime.format("HH:mm")

				//make sure daily start time is not before the parent's start time. This may occur if the start time between the source parent event differs from the duplicated event
				if (vm.moment(payload.start_time).isBefore(vm.moment(jobEvent.start_time)))
					payload.start_time = jobEvent.start_time

				let jobEndTime = vm.moment(jobEvent.end_time)
				let eventEndTime = vm.moment(vm.duplicateConfirmModal.eventPayload.end_time)
				payload.end_time = jobEndTime.format("YYYY-MM-DD") + " " + eventEndTime.format("HH:mm")

				//do the same for end time -- constrain to parent event end time
				if (vm.moment(payload.end_time).isAfter(vm.moment(jobEvent.end_time)))
					payload.end_time = jobEvent.end_time

				payload.parent_event_id = jobEvent.id

				if (payload.start_time != vm.duplicateConfirmModal.eventPayload.start_time)
					//make sure we're not creating a duplicate
					promises.push(vm.postData("ScheduleEvent/save",payload))
			})

			Promise.all(promises).then(response => {
				vm.duplicateConfirmModal.visible = false
				vm.duplicateConfirmModal.working = false
				vm.fetchScheduleEvents()
			})
		},
		fetchRelatedJobEvents(key,job_id,futureOnly) {
			let vm = this

			let params = {
				filters: [
					[key,job_id],
					["user_id",0],
					["equipment_id",0],
					["is_published",0]
				]
			}

			if (futureOnly)
				params.filters.push(["start_time >",this.selectedDate])

			return new Promise((resolve,reject) => {
				vm.getJSON("ScheduleEvent/get",params).then(response => {
					resolve(response)
				})
			})
		},
		fetchScheduleEvents(spinner, isPreloaded) {
			let vm = this

			if (spinner)
				vm.spinner(true)

			return new Promise((resolve,reject) => {

				let payload = {
					include: this.eventIncludes
				}

				if (isPreloaded) {
					payload.start_time = this.calendarViewTimeRange.from.startOf("month").utc().format("YYYY-MM-DD HH:mm")
					payload.end_time = this.calendarViewTimeRange.to.endOf("month").utc().format("YYYY-MM-DD HH:mm")
				}
				else {
					payload.start_time = this.calendarViewTimeRange.from.utc().format("YYYY-MM-DD HH:mm")
					payload.end_time = this.calendarViewTimeRange.to.utc().format("YYYY-MM-DD HH:mm")
				}

				vm.getJSON("ScheduleEvent/get-range",payload).then(response => {
					if (response.success)  {

						if (isPreloaded)
							vm.preloadedEvents = response.data
						else {
							vm.events = response.data

							vm.scheduleRows = vm.renderScheduleRows(vm.events,vm.equipmentServices)
						}
					}

					if (spinner)
						vm.spinner(false)

					resolve(response)
				})

			})
		},
		fetchEquipmentServices() {
			let vm = this

			let params = {
				filters: [
					["next_service_date >=",this.calendarViewTimeRange.from.format("YYYY-MM-DD")],
					["next_service_date <=",this.calendarViewTimeRange.to.format("YYYY-MM-DD 23:59:39")],
					["archived",0]
				],
				fields: ["id","slug","next_service_date","next_service_mileage_or_time","description","next_service_description"]
			}

			return new Promise((resolve,reject) => {

				vm.getJSON("Equipment/get",params).then(response => {
					if (response.success) 
						vm.equipmentServices = response.data

					resolve(response)
				})

			})
		},
		fetchEvent(idOrSlug) {
			let vm = this

			return new Promise((resolve,reject) => {
				vm.getJSON("ScheduleEvent/find/"+idOrSlug,{include: vm.eventIncludes}).then(response => {
					if (response.success)
						vm.events.push(response.data)
				})
			})
		},
		fetchAllEvents(spinner) {
			let vm = this

			if (spinner)
				vm.spinner(true)

			let promises = [
				this.fetchScheduleEvents()
			]

			if (this.filters.mainTypes.indexOf("equipment-servicing") >= 0)
				promises.push(this.fetchEquipmentServices())

			//if (this.calendarView == 'daily' && vm.preloadedEvents.length == 0)
			//	this.fetchScheduleEvents(false,true)

			return new Promise((resolve,reject) => {
				Promise.all(promises).then(responses => {
					if (spinner)
						vm.spinner(false)

					resolve(responses)
				})
			})
		},
		fetchData() {
			let vm = this

			let promises = [
				this.fetchAllEvents()
			]

			let userParams = {
				fields: ["id","slug","first_name","last_name"],
				include: ["EmployeeSetting"]
			}

			this.getJSON("User/get",userParams).then(response => {
				if (response.success)
					vm.users = vm.cloneObj(response.data)
			})
			this.fetchJobs(
				[
					{
						model: "User",
						fields: ["id","first_name","last_name"],
					}
				],
				[],
				["job_name","job_num"]
			)

			this.fetchServices(
				[
					{
						model: "User",
						fields: ["id","first_name","last_name"],
					}
				],
				[
					['archived',0],
					//["status !=","Completed"],
					//["status !=","Invoiced"],
					["status !=","Canceled"]
				],
				["id","slug","job_name","job_num","status","customer_id","Customer","helper_techs_json","address","city","postal_code","customer_name_cache"]
			)

			this.spinner(true)

			Promise.all(promises).then(responses => {
				vm.spinner(false)
			})
		}
	},
	created() {
		this.initFilters()
		this.initView()
		this.initSelectedDate()
		
		this.fetchData()
		this.initScheduleEntities()

		//check if device is touchscreen
		if (window.matchMedia("(pointer: coarse)").matches)
			this.isTouchscreen = true

		if (window.innerWidth <= 1000)
			this.calendarView == 'daily'
	},
	mounted() {
		this.setScheduleRowsHeight()
	},
	updated() {
		this.setScheduleRowsHeight()
	}
}

</script>

<style type="text/css">
	html {
		/*overflow-y: hidden;*/
	}

	.main-container {
		padding-bottom: 0!important;
	}
</style>

<style type="text/css">

	.schedule-top-controls-container {
		display: flex;
		align-items: center;
		margin-top: -10px;
		margin-bottom: -10px;
	}

	.schedule-top-controls-container .schedule-heading {
		width: 230px;
		text-align: center;
	}

	.inner-scroll {
		overflow-y: auto;
		overflow-x: hidden;
		margin-left: -10px;
		margin-right: -10px;
		max-height: calc(100vh - 112px);
	}

	.inner-scroll h3 {
		margin-left: 10px;
	}

	.drop-target {
		position: absolute;
		left: 0;
		width: 100%;
		text-align: center;
		box-shadow: 0 0 5px inset blue;
		top: 0;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.schedule-grid {
		
	}

	.day-view {
		overflow: auto;
		width: 100%;
		height: 100%;
		border: 1px solid var(--background-menus);
	}

	.day-view.fixed-height {
		height: 500px;
	}

	.day-view-inner .schedule-rows {
		overflow: auto;
		width: 100%;
		position: relative;
	}

	.time-axis,
	.add-to-schedule-droppable {
		width: 60px;
		background-color: white;
		color: #17a2b8;
		text-align: center;
		font-size: 11pt;
		display: inline-block;
	}

	.time-axis {
		width: 100%;
		display: block;
		background-color: var(--background-menus);
		color: #455A64;
	}

	.time-block {
		padding-left: 5px;
		padding-right: 5px;
		/*border: 1px solid var(--background-menus);*/
		display: flex;
		align-items: center;
		display: inline-block;
	}

	.day-divider-line,
	.current-time-indicator-line {
		position: absolute;
		top: 0;
		bottom: 0;
		width: 2px;
		border-left: 1px solid red;
		z-index: 19;
	}

	.current-time-indicator-line {
		width: 30px;
		background: linear-gradient(to right, transparent, transparent, rgba(0,0,255,0.4), transparent,transparent); 
		border: none;
	}

	.add-to-schedule-droppable {
		width: 100%;
	}

	.add-to-schedule-droppable .droppable-block {
		border: 1px solid var(--background-menus);
		display: inline-block;
		position: relative;
	}

	.droppable-block * {
		overflow: hidden;
		height: 100%!important;
		width: 100%!important;
		margin: 0;
		background-color: var(--brand-primary-color);
	}

	.droppable-block * .inner {
		display: none;
	}

	.off-droppable-block {
		position: relative;
		height: 38px;
		display: inline-block;
		margin-bottom: 0;
		background-color: white;
		padding: 0;
		width: calc(100% - 15px);
		overflow: hidden;
		margin-top: 5px;
	}

	.off-droppable-block span {
		display: block;
		position: relative;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		padding: 7px;
		text-align: center;
	}

	.schedule-row {
		position: relative;
		width: 100%;
		overflow: hidden;

	}

	/*
	.schedule-row.project-related-row {
		background-color: #7c61f31c;
	}

	.schedule-row.service-related-row {
		background-color: #61f3af1c;
	}
	*/

	.schedule-row.job-row {
		border-top: 1px solid var(--background-menus);
	}

	.scheduled-item-block {
		background-color: #fff;
		border: 1px solid rgba(0,0,0,.125);
		border-radius: 4px;
		padding: 8px;
	}

	.scheduled-item {
		position: absolute;
		width: 0;
	}

	.scheduled-item-inner {
		position: relative;
		background-color: var(--background-light);
		border-radius: 4px;
		border: 1px solid rgba(0,0,0,.125);
		padding: 5px;
		font-size: 9pt;
		cursor: pointer;
		overflow: hidden;
	}

	.scheduled-item-inner.is-project-tile {
		background-color: #7c61f31c;
	}

	.scheduled-item-inner.is-service-tile {
		background-color: #61f3af1c;
	}

	.scheduled-item-inner.starts-to-left {
		border-left: none;
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
	}

	.scheduled-item-inner.is-empty-block {
		background-color: #a1a1a1;
	}

	.scheduled-item-resizing {
		border-left: 4px solid #a0a0a0;
		border-right: 4px solid #a0a0a0;
	}

	.scheduled-item .handle {
		height: 100%;
		width: 8px;
		background-color: #a0a0a0;
		display: block;
		position: absolute;
		z-index: 10;
		margin-top: -5px;
		cursor: col-resize;
	}

	.scheduled-item .handle.handle-ml {
		left: -4px;
	}

	.scheduled-item .handle.handle-mr {
		right: -4px;
	}

	.scheduled-item-details {
		display: block;
		overflow-x: hidden;
		white-space: -moz-nowrap; /* Firefox */
		white-space: -o-nowrap; /* Opera */
		white-space: nowrap; /* Chrome */
	}

	/*.active .scheduled-item-details {
		display: none;
	}*/

	.scheduled-item-controls {
		display: none;
		width: 50px;
		text-align: center;
	}

	.scheduled-item-controls .btn-sm {
		padding: 2px;
		padding-left: 7px;
		padding-right: 7px;
	}

	.active .scheduled-item-controls {
		display: block;
	}

	.active .hide-details-on-active .scheduled-item-details {
		display: none;
	}

	.info-modal h3,
	.info-modal .info-field{
		text-transform: uppercase;
	}

	.schedule-top-controls-container {
		display: block;
	}

	@media (max-width: 1650px) {
		
	}

	@media (max-width: 1000px) {

		h2 {
			font-size: 16pt;
		}

		.heading-block {
			max-width: calc(100% - 30px);
		}

		.add-to-schedule-full-button-text {
			display: none;
		}
		
	}

	@media (max-width: 400px) {
		h2 {
			font-size: 16pt;
		}
	}
</style>